import { render, staticRenderFns } from "./consult-info1.vue?vue&type=template&id=5b6aa43b&scoped=true"
import script from "./consult-info1.vue?vue&type=script&lang=js"
export * from "./consult-info1.vue?vue&type=script&lang=js"
import style0 from "./consult-info1.vue?vue&type=style&index=0&id=5b6aa43b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6aa43b",
  null
  
)

export default component.exports